import { IconProps } from "@/types/types";

export default function Chevron({ width = "24", height = "24", className }: IconProps) {
    return (
        <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path d="M15.4559 5.81284L9.26874 12L15.4559 18.1872C15.5169 18.2482 15.5703 18.314 15.6161 18.3833C15.9364 18.8685 15.883 19.5278 15.4559 19.955C14.9678 20.4431 14.1763 20.4431 13.6881 19.955L6.61709 12.8839C6.58779 12.8546 6.56009 12.824 6.53406 12.7922C6.35181 12.5698 6.25098 12.2901 6.25098 12C6.25098 11.6685 6.38267 11.3506 6.61709 11.1161L13.6881 4.04507C14.1763 3.55692 14.9678 3.55692 15.4559 4.04507C15.5169 4.10609 15.5703 4.17185 15.6161 4.24116C15.9364 4.72635 15.883 5.3857 15.4559 5.81284Z" fill="currentColor" />
        </svg>
    )
}

